import Api from 'libs/api/index';

class VacancyCategoriesApi extends Api {
  constructor() {
    super('cv/vacancy_categories/');
  }
}

export default VacancyCategoriesApi;
